import { Component, OnInit, Inject, ViewChild, Input, ViewEncapsulation, ElementRef } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectInfo } from '../model/project.model';
import { LookupInfo } from '../model/lookup.model';
import { ProjectDeliveryCostInfo } from '../model/ProjectDeliveryCost.model';
import { CostItemInfo } from '../model/CostItem.model';
import { ProjectDeliveryCostAttachedmentInfo } from '../model/ProjectDeliveryCostAttachedment.model';
import { ProjectDocumentInfo } from '../model/projectdocument.model';
import { IssueInfo } from '../model/issue.model';
import { IssueManagementComponent, summaryInfo, summarydetailInfo } from '../issue-management/issue-management.component'; //Add from lesson learned tab
import { GanttChartControlComponent } from "../gantt-chart-control/gantt-chart-control.component";
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { BaselineInfo } from '../model/baseline.model';
import { GlobalService } from '../service/global.service';
import { Chart, ChartType, ChartOptions } from 'chart.js'; //Add from lesson learned tab
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts'; //Add from lesson learned tab

import { Observable, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import * as Papa from 'papaparse';
import { ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
import {
  HttpEventType,
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { data } from 'jquery';
import { NgModule } from '@angular/core';
import { async } from '@angular/core/testing';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';
import { StateInfo } from '../model/StateInfo.model';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { EmpInfo } from '../model/emp.model';


let today = new Date().toISOString()

@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./project-detail.component.css']
})
export class ProjectDetailComponent implements OnInit {
  @ViewChild(GanttChartControlComponent) ganttchart;
  @Input() ProjectCode: string;
  @ViewChild('fileUploader') fileUploader: ElementRef;
  @ViewChild('filePOUploader') filePOUploader: ElementRef;
  @ViewChild('fileWorkUploader') fileWorkUploader: ElementRef;

  // Add from lesson learned tab
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };  

  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];

  // End Add from lesson learned tab

  displayloading: boolean = false;
  Msgloadding: string = '';
  public body: string;
  ProjectPromise: Promise<ProjectInfo[]>  
  ProjectList: ProjectInfo[]
  ProjectStatusList: LookupInfo[]

  // flag display for Manager Only and not State Completed or terminate
  IsShowForThisManager: boolean;

  _ParamProjectCode: string
  _ParamProjectName: string
  _ParamCompanyName: string
  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;

  titlemodal: string
  detailmodal: string

  txtProjectCode: string
  txtProjectName: string
  txtProjectShortName: string
  txtPOOrderNo: string
  txtWorkOrderNo: string
  txtProjectStart: string
  txtProjectEnd: string
  ddlProjectStatus: string
  ddlProjectStatusSavedraft: string

  hidProjectId: number
  public currentPageNumber: number
  public totalPages: number
  ProjectTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  txtProjectComment: string;

  // variable  Project Document Zone
  ProjectDocumentPromise: Promise<ProjectDocumentInfo[]>
  ProjectDocumentList: ProjectDocumentInfo[]
  ddlSupportContractType: string = null;
  ddlProjectType: string = null;
  ddlWarrantyType: string = null;
  ddlMAType: string = null;
  txtWarrantyStartDate: string = null;
  txtWarrantyEndDate: string = null;
  txtMAStartDate: string = null;
  txtMAEndDate: string = null;
  ddlPackage: number = null;

  SupportContractTypeList: any;
  ProjectTypeList: any;
  WarrantyTypeList: any;
  MATypeList: any;
  ProjectPackageList: any;

  ddlSubscriptType: string = null;
  SubscriptTypeList: any;
  txtSubscriptionStartDate: string = null;
  txtSubscriptionEndDate: string = null;

  ddlPerputualType: string = null;
  PerputualTypeList: any;
  // End variable  Project Document Zone
  //ย้ายไป Event Component
  // Variable Lesson Learned Zone
  issueListAll: IssueInfo[]
  IssuePromise: Promise<IssueInfo[]>
  summaryInfo = new summaryInfo;
  baselineListSortbybaselineId: BaselineInfo[];

  IssueSummaryTotal: any

  lblbaselinestartdate: string;
  lblbaselineenddate: string;
  lblbaselinetotaldays: number;
  lblactualstartdate: string;
  lblactualenddate: string;
  lblactualtotaldays: number;
  lbloverduedays: number;
  totalticket: number;
  // End Variable Lesson Learned Zone

  // Variable Event Zone
  
  // End Variable Event Zone

  _RoleCode: string;

  // Dashboard variable
  inlineCheckboxBaselinePlan: boolean
  inlineCheckboxActualPlan: boolean
  SelectPlan: string = 'baseline,actual,';
  public TabProjectPlanIndex = 1;
  public TabOrganizationalIndex = 1;

  Stagelist: any;
  Actionlist: any;

  // variable flag insert update project cost
  isProjectDeliveryBudgetAttachedFileSubmitted: any;
  isProjectDeliveryCostAttachedmentSubmitted: any;
  // project delivery id from parameter
  @Input() ProjectDeliveryID: string;
  @Input() isViewOnly: boolean = false;
  _ParamProjectDeliveryID: string

  // Form Group
  ProjectDetailForm: FormGroup;


  // Form Group for Assign Member
  AssignMemberForm: FormGroup;
  // array control Assign Member
  itemsAssignMemberForm_array: FormArray;
  // array of remove AssignMember
  //itemsRemoveAssignMember_array: ProjectMemberInfo[] = [];
  // Emp List for Assign Member
  EmployeeList: EmpInfo[] = [];
  // Lookup MASTERPROJECTROLE List for Assign Member
  PositionInProjectList: LookupInfo[] = [];

  // Assign Member Lead List
  AssignMemberLeadList: ProjectMemberInfo[] = [];

  // show only Manager
  IsShowForThisUserOtherManager: boolean;
  // Emp Manager current project
  EmpManager: string
  EmpManagerDisplayName: string


  // array control
  itemsSetup: FormArray;
  itemsBaseline: FormArray ;

  BaselineList: BaselineInfo[];
  BaselineTimeList: BaselineInfo[];

  // Org Chat
  filesToUpload: File[];
  pathImg: string = '';

  //Base line document
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';

  ListState: StateInfo[] = [];

  //empselect
  employeeselectrun: boolean = false;
  employeeselectreturnto: number;
  selectedemp: EmpInfo;

  //PO document
  poFileName: string = '';
  poOrderPathFile: string = '';
  poFilesToUpload: File[];
  poPathFile: string = 'Resources\\Project';

  //Work Order document
  workorderFileName: string = '';
  workOrderPathFile: string = '';
  workorderFilesToUpload: File[];
  workorderPathFile: string = 'Resources\\Project';
  resultUploadfile: any;


  SubProjectPromise: Promise<ProjectInfo[]>
  SubProjectList: ProjectInfo[] = [];
  txtSearchSubProjectCode: string
  txtSearchSubProjectName: string
  isSubSearchSubmitted: boolean = false;
  isSubSubmitted: any;
  subscriptionLoadSubProjectList: Subscription
  subscriptionCountSubProjectList: Subscription

  TabSubProjectIndex = 1;

  // valiable project cost
  projectdeliveryCostFilesToUpload: File[];
  CostItemList: CostItemInfo[] = [];
  projectdeliveryCostPathFile: string = '';

  validatetxtProjectDeliveryCostItemCode: string
  // validatetxtProjectDeliveryCostItemName: string
  validatetxtProjectDeliveryCostType: string
  validatetxtProjectDeliveryCostQuantity: string
  validatetxtProjectDeliveryCostUnitCost: string

  IsClearList: string = ';'
  IsClearProjectDeliveryCostAttachedmentList: string = ';';

  modalDocName: string;
  modalDocInfo: any;

  public currentSubPageNumber: number
  public SubProjectTotal: number
  public totalSubPages: number

   // ProjectDeliveryCost List and variable item
    ProjectDeliveryCostList: ProjectDeliveryCostInfo[] = [];
    public currentPageProjectDeliveryCostNumber: number = 1
    public totalProjectDeliveryCostPages: number
    public ProjectDeliveryCostTotal: number
  
    ProjectDeliveryCostAttachedmentList: ProjectDeliveryCostAttachedmentInfo[]
    ProjectDeliveryCostTypeList: LookupInfo[]
  
    txtProjectDeliveryCostItemCode: string
    // txtProjectDeliveryCostItemName: string
    txtProjectDeliveryCostType: string
    txtProjectDeliveryCostQuantity: number
    txtProjectDeliveryCostUnit: string
    txtProjectDeliveryCostUnitCost: number
    txtProjectDeliveryCostAmount: number
    hidprojectdeliverycostId: number

  formSetup: FormGroup;

  async ngOnInit() {

    this.currentPageNumber = 1;
    this.TabProjectPlanIndex = 1;
    this.SetSelectTabProject(1);
    this.SetSelectTabOrganizational(1);
    this.inlineCheckboxBaselinePlan = true;
    this.inlineCheckboxActualPlan = true;


    this.currentSubPageNumber = 1;
    this.TabSubProjectIndex = 1;
    

    
    this._EmpCode = !!this._EmpCode ? this._EmpCode : localStorage.getItem("EmpCode");
    this._RoleCode = !!this._EmpRoleCode ? this._EmpRoleCode : localStorage.getItem('EmpRoleCode');
    this._ParamProjectCode = !!this._ParamProjectCode ? this._ParamProjectCode : this.GetParam('ProjectCode').toString();

    // show only MANAGER
    this.IsShowForThisUserOtherManager = (this._RoleCode == "MANAGER" || this._RoleCode == "PROJECTCO");

    // Add from lesson learned tab
    Chart.defaults.global.legend.display = false;
    Chart.defaults.global.defaultFontSize = 18;
    // End Add from lesson learned tab

    await this.loadDDLSupportContractType().then((data) => {
      this.SupportContractTypeList = data
    });

    await this.loadDDLProjectType().then((data) => {
      
      this.ProjectTypeList = data
    });
    //await this.loadDDLWarrantyType().then((data) => {
    //  this.WarrantyTypeList = data
    //});
    //await this.loadDDLMAType().then((data) => {
    //  this.MATypeList = data
    //});
   await this.LoadStateList("3").then((data) => {
      this.WarrantyTypeList = data;
    });
    await this.LoadStateList("4").then((data) => {
      this.MATypeList = data
    });
    await this.LoadStateList("6").then((data) => {
      this.SubscriptTypeList = data
    });
    await this.LoadStateList("7").then((data) => {
      this.PerputualTypeList = data
    });

    await this.loadDDLPackage().then((data) => {
      this.ProjectPackageList = data
    });

    

    this.LoadProjectDetail();
    this.loadDDLStage();
    this.LoadStateList().then((data) => {
      this.ListState = data;
    });
   
    await this.loadDDLPriorty().then((data) => {
      this.Actionlist = data
    });

    // Load lookup for COSTTYPE
    this.loadLookup('COSTTYPE').then((data) => {
      this.ProjectDeliveryCostTypeList = data;
    });

    // Load all Cost Items
    await this.loadCostItemList().then((data) => {
      this.CostItemList = data;
    });

    // create control
    this.ProjectDetailForm = await this.formBuilder.group({
      BaselineForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemBaselineDefault()])
      }) ,
      SetupForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemSetupDefault()])
      }),
      AssignMemberForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemAssignMemberDefault()])
      }) 
    });


    // set AssignMemberForm from InformationForm
    this.AssignMemberForm = this.ProjectDetailForm.get('AssignMemberForm') as FormGroup

    // get items array to itemsAssignMemberForm_array
    this.itemsAssignMemberForm_array = this.AssignMemberForm.get('items') as FormArray;

    
    this.itemsBaseline = await this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;
    this.itemsBaseline.clear();
    
    this.GetBaselineToBaseline();
    this.GetBaselineToSetUp();

    // Add from lesson learned tab
    this.GetBaselineToLessonLearned();
    this.LoadIssueAll();
    // End Add from lesson learned tab

    this.LoadSubProjectAndCount()

    // Load Project Cost
    // this.validatetxtProjectSaleBudgetGLName = 'False';
    // this.validatetxtProjectDeliveryBudgetAmount = 'False';
    this.validatetxtProjectDeliveryCostItemCode = 'False';
    // this.validatetxtProjectDeliveryCostItemName = 'False';
    this.validatetxtProjectDeliveryCostType = 'False';
    this.validatetxtProjectDeliveryCostQuantity = 'False';
    this.validatetxtProjectDeliveryCostUnitCost = 'False';

    this.loadLookup('PROJECTDELIVERYEXPENSE').then((data) => {
      this.ProjectDeliveryCostTypeList = data;
    })

    this.IsClearList = "false";
    this.IsClearProjectDeliveryCostAttachedmentList = "false";

    this.LoadProjectDeliveryCost();
    this.OnLoadCountProjectDeliveryCostList();
    this.formSetup = this.formBuilder.group({
      itemsSetup: this.formBuilder.array([])
    });
  }
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private router: Router,
              private fb: FormBuilder,
                private cdRef: ChangeDetectorRef) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._EmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ///////////////////////////////////////Events////////////////////////////////////////////
  btnClick_showProjectList() {
  }

  onSelectBoxChange(event: any, id: string) {
    const proType = event.target.value;
    if (id == '1' || id == '3') {
      $('#partPONo').hide();
      $('#partPOAttachment').hide();
      $('#partWorkNo').hide();
      $('#partWorkAttachment').hide();
    } else {
      $('#partPONo').show();
      $('#partPOAttachment').show();
      $('#partWorkNo').show();
      $('#partWorkAttachment').show();
    }
    // Handle the new value of the text input here
    //console.log('New value:', proType);
  }

  onLoadSelectBoxChange(id: string) {
    if (id == '1' || id == '3') {
      $('#partPONo').hide();
      $('#partPOAttachment').hide();
      $('#partWorkNo').hide();
      $('#partWorkAttachment').hide();
    } else {
      $('#partPONo').show();
      $('#partPOAttachment').show();
      $('#partWorkNo').show();
      $('#partWorkAttachment').show();
    }
    // Handle the new value of the text input here
    //console.log('New value:', proType);
  }

  ///////////////////////////////////////Functions/////////////////////////////////////////

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectDocument"]').prop('checked', check);

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  async loadCostItemList(): Promise<CostItemInfo[]> {
    const auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = { FlagDelete: 'N' };
      const strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<CostItemInfo[]>(this.baseurl + 'CostItem/GetCostItem', strjson, httpOptions)
        .toPromise();
    }
  }

  // Call this on Item Code change in modal
  onChangeCostItemCode(code: string) {
  const selectedItem = this.CostItemList.find(x => x.CostItemCode === code);
  if (selectedItem) {
    // this.txtProjectDeliveryCostItemName = selectedItem.CostItemName;
    this.txtProjectDeliveryCostType = selectedItem.CostItemTypeName;
  } else {
    // this.txtProjectDeliveryCostItemName = '';
    this.txtProjectDeliveryCostType = '';
  }
}

  async LoadProjectDetail() {
    var auth_token = await this.TokenService.RefreshToken();
    this.loadDDLStatus(auth_token)
      .subscribe({
        next: data => {
          this.ProjectStatusList = data;
          if (this.ProjectStatusList.length) {
            // Get Project Detail
            this.LoadProjectList(auth_token)
              .subscribe({
                next: data => {
                  this.ProjectList = data;
                  if (this.ProjectList.length) {
                    this.isOnUpdate = true

                   

                    this.ddlProjectStatus = this.ProjectList[0].ProjectStatusCode != null ? this.ProjectList[0].ProjectStatusCode : null
                    this.ddlProjectStatusSavedraft = this.ddlProjectStatus;
                    this.txtProjectCode = this.ProjectList[0].ProjectCode != null ? this.ProjectList[0].ProjectCode : null
                    this.txtProjectName = this.ProjectList[0].ProjectName != null ? this.ProjectList[0].ProjectName : null
                    this.txtProjectShortName = this.ProjectList[0].ProjectShortName != null ? this.ProjectList[0].ProjectShortName : null
                    this.txtPOOrderNo = this.ProjectList[0].POOrderNo != null ? this.ProjectList[0].POOrderNo : null
                    this.txtWorkOrderNo = this.ProjectList[0].WorkOrderNo != null ? this.ProjectList[0].WorkOrderNo : null
                    this.txtProjectStart = this.ProjectList[0].ProjectStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectStart) : null
                    this.txtProjectEnd = this.ProjectList[0].ProjectEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectEnd): null

                    this.ddlSupportContractType = this.ProjectList[0].ProjectSupportContractTypeCode != null ? this.ProjectList[0].ProjectSupportContractTypeCode : null
                    this.ddlProjectType = this.ProjectList[0].ProjectTypeCode != null ? this.ProjectList[0].ProjectTypeCode : null

                    this.onLoadSelectBoxChange(this.ddlProjectType);

                    this.ddlWarrantyType = this.ProjectList[0].ProjectWarrantyTypeCode != null ? this.ProjectList[0].ProjectWarrantyTypeCode : null
                    this.ddlMAType = this.ProjectList[0].ProjectMATypeCode != null ? this.ProjectList[0].ProjectMATypeCode : null
                    this.txtWarrantyStartDate = this.ProjectList[0].ProjectWarrantyStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectWarrantyStart) : null
                    this.txtWarrantyEndDate = this.ProjectList[0].ProjectWarrantyEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectWarrantyEnd) : null
                    this.txtMAStartDate = this.ProjectList[0].ProjectMAStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectMAStart) : null
                    this.txtMAEndDate = this.ProjectList[0].ProjectMAEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectMAEnd) : null
                    this.ddlPackage = this.ProjectList[0].ProjectPackage != null ? this.ProjectList[0].ProjectPackage : null
                    this.pathImg = this.ProjectList[0].ProjectImgPath != null ? this.ProjectList[0].ProjectImgPath : null
                    this.txtProjectComment = this.ProjectList[0].Comment != null ? this.ProjectList[0].Comment : null
                    this.ddlSubscriptType = this.ProjectList[0].ProjectSubscriptType != null ? this.ProjectList[0].ProjectSubscriptType : null
                    this.txtSubscriptionStartDate = this.ProjectList[0].ProjectSubscriptStart != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectSubscriptStart) : null
                    this.txtSubscriptionEndDate = this.ProjectList[0].ProjectSubscriptEnd != null ? this.GlobalService.formatDate(this.ProjectList[0].ProjectSubscriptEnd) : null
                    this.hidProjectId = this.ProjectList[0].ProjectId
                    this.poFileName = this.ProjectList[0].POOrderFileName
                    this.workorderFileName = this.ProjectList[0].WorkOrderFileName
                    this.workOrderPathFile = this.ProjectList[0].WorkOrderPathFile
                    this.poOrderPathFile = this.ProjectList[0].POOrderPathFile

                    this.ddlPerputualType = this.ProjectList[0].ProjectPerputualType != null ? this.ProjectList[0].ProjectPerputualType : null

                    if (this.pathImg != null) {
                      $('#previewImg').show();
                    } else {
                      $('#previewImg').hide();

                    }

                    if (this.poFileName != null) {
                      $('#dowloadPO').show();
                    } else {
                      $('#dowloadPO').hide();

                    }

                    if (this.workorderFileName != null) {
                      $('#dowloadWorkOrder').show();
                    } else {
                      $('#dowloadWorkOrder').hide();

                    }

                    this._ParamProjectName = this.txtProjectName;
                    this._ParamCompanyName = this.ProjectList[0].ProjectCompanyName;

                    // flag display for Manager Only and not State Completed & terminate &  Waranty-Completed
                    this.IsShowForThisManager = ((this.ProjectList[0].ProjectAssignPM == this.checkUndefinedString(localStorage.getItem("EmpCode")) || this.ProjectList[0].ProjectAssignPCO == this.checkUndefinedString(localStorage.getItem("EmpCode"))) && (this.ProjectList[0].ProjectStateCode != '0' && this.ProjectList[0].ProjectStateCode != '2-8' && this.ProjectList[0].ProjectStateCode != '3-2'))

                  }


                },
                error: error => {
                  console.error('There was an error!', error);
                }
              })

          }


        },
        error: error => {
          console.error('There was an error!', error);
        }
      })

    




  }

  async btnClick_submitUpdateProject(id) {
    if (this.ddlProjectType == '2') {
      if ((!this.txtPOOrderNo && !this.poFilesToUpload) && (!this.txtWorkOrderNo && !this.workorderFilesToUpload))
        return;
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      $('#ProjectDetailZone *').attr('disabled', 'true'); // set disable all control
      $('#loadingupdate').show(); // show button update loading
      $('#btnupdate').hide(); // hide button update

      id = this.hidProjectId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      this.validateData();

      var objectjson = {};
      objectjson['ProjectCode'] = this.checkUndefinedString(this.txtProjectCode);
      objectjson['ProjectName'] = this.checkUndefinedString(this.txtProjectName);
      objectjson['ProjectShortName'] = this.checkUndefinedString(this.txtProjectShortName);
      objectjson['POOrderNo'] = this.checkUndefinedString(this.txtPOOrderNo);
      objectjson['WorkOrderNo'] = this.checkUndefinedString(this.txtWorkOrderNo);
      objectjson['ProjectStart'] = new Date(this.checkUndefinedString(this.txtProjectStart))
      objectjson['ProjectEnd'] = new Date(this.checkUndefinedString(this.txtProjectEnd))
      objectjson['ProjectStatusCode'] = this.ddlProjectStatus
      objectjson['ProjectTypeCode'] = this.ddlProjectType

      if (this.fileUploader.nativeElement.value == null) {
        objectjson['ProjectImgPath'] = null;
      } else {
        objectjson['ProjectImgPath'] = this.checkUndefinedString(this.pathImg);
      }
      
      if (this.ddlProjectStatus == '3') { // if status is complate
        objectjson['ProjectSupportContractTypeCode'] = this.ddlSupportContractType;
        if (this.ddlSupportContractType == "2") {
          //Waranty
          objectjson['ProjectStateCode'] = this.ddlMAType 
        } else if (this.ddlSupportContractType == "1") {
          //MA
          objectjson['ProjectStateCode'] = this.ddlWarrantyType
        } else if (this.ddlSupportContractType == "3") {
          //Perputation
          objectjson['ProjectStateCode'] = this.ddlPerputualType
        } else if (this.ddlSupportContractType == "4") {
          //Subscription
          objectjson['ProjectStateCode'] = this.ddlSubscriptType
        }
        
        objectjson['ProjectWarrantyTypeCode'] = this.ddlWarrantyType;
        objectjson['ProjectMATypeCode'] = this.ddlMAType;
        objectjson['ProjectWarrantyStart'] = new Date(this.checkUndefinedString(this.txtWarrantyStartDate))
        objectjson['ProjectWarrantyEnd'] = new Date(this.checkUndefinedString(this.txtWarrantyEndDate))
        objectjson['ProjectMAStart'] = new Date(this.checkUndefinedString(this.txtMAStartDate))
        objectjson['ProjectMAEnd'] = new Date(this.checkUndefinedString(this.txtMAEndDate))

        objectjson['ProjectSubscriptType'] = this.ddlSubscriptType
        objectjson['ProjectSubscriptStart'] = new Date(this.checkUndefinedString(this.txtSubscriptionStartDate))
        objectjson['ProjectSubscriptEnd'] = new Date(this.checkUndefinedString(this.txtSubscriptionEndDate))

        objectjson['ProjectPerputualType'] = this.ddlPerputualType

        objectjson['ProjectPackage'] = this.ddlPackage
      }


      objectjson['FlagDelete'] = "N";
      objectjson['ProjectId'] = id
      objectjson['UpdateBy'] = this._EmpCode;

      if (this.ddlProjectType == '2' && this.poFilesToUpload) {
        var isUploadSuccess = await this.UploadPOFilesToServer(this.poFilesToUpload);
        if (isUploadSuccess) {
          for (const val of this.poFilesToUpload) {
            objectjson['POOrderFileName'] = val.name;
            objectjson['POOrderPathFile'] = this.poPathFile + "\\" + val.name;
          }
        }
      } else if (!this.poFilesToUpload && !this.poFileName) {
        objectjson['POOrderFileName'] = this.poFileName;
        objectjson['POOrderPathFile'] = this.poOrderPathFile;
      } else {
        objectjson['POOrderFileName'] = null;
        objectjson['POOrderPathFile'] = null;
      }

      if (this.ddlProjectType == '2' && this.workorderFilesToUpload) {
        var isUploadSuccess = await this.UploadPOFilesToServer(this.workorderFilesToUpload);
        if (isUploadSuccess) {
          for (const val of this.workorderFilesToUpload) {
            objectjson['WorkOrderFileName'] = val.name;
            objectjson['WorkOrderPathFile'] = this.workorderPathFile + "\\" + val.name;
          }
        }
      } else if (!this.workorderFilesToUpload && !this.workorderFileName) {
        objectjson['WorkOrderFileName'] = this.workorderFileName;
        objectjson['WorkOrderPathFile'] = this.workorderPathFile;
      } else {
        objectjson['WorkOrderFileName'] = null;
        objectjson['WorkOrderPathFile'] = null;
      }


      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "Project/UpdateProject", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Update fail")
          $('#ProjectDetailZone *').removeAttr('disabled'); // unset disable all control
          $('#loadingupdate').hide(); // hide button update loading
          $('#btnupdate').show(); // show button update

          this.titlemodal = 'Update Project Detail Update fail.';
          this.detailmodal = 'Your project datail was Update fail.';
          $('#ModalError').modal();
        },
          () => {
            console.log("Update = " + this.isSubmitted)
            $('#ProjectDetailZone *').removeAttr('disabled'); // unset disable all control
            $('#loadingupdate').hide(); // hide button update loading
            $('#btnupdate').show(); // show button update

            this.titlemodal = 'Update Project Detail done.';
            this.detailmodal = 'Your project datail was updated successfully.';
            $('#ModalComplate').modal();
            this.LoadProjectDetail();
          }
        );
    }
  }

   loadDDLStatus(auth_token): Observable<LookupInfo[]> {
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"PROJECTSTATUS\" }";

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
    }
  }

  async selectedTabChange(traget) {
 
    if (traget.tab.textLabel == 'Detail') {
      this.LoadProjectDetail();
    } else if (traget.tab.textLabel == 'Document') {
    } else if (traget.tab.textLabel == 'Timeline & Project Plan') {  // Change Main tab (html) Label 'Dashboard' to 'Timeline & Project Plan'
      this.ganttchart.OnloadBaseline(false, this.SelectPlan);
      this.GetBaselineToBaseline();
      this.GetBaselineToSetUp();
    } else if (traget.tab.textLabel == 'Event') {
    } else if (traget.tab.textLabel == 'Project Plan') {
      this.OnClickBack();
      $($('mat-ink-bar')[1]).css("width", "160px");

    } else if (traget.tab.textLabel == 'Lesson Learned') { // Add from lesson learned tab
      this.GetBaselineToLessonLearned(); // Add from lesson learned tab
    }                                    // Add from lesson learned tab
    else if (traget.tab.textLabel == 'Assign Member') {
      await this.ReLoadAssignMember();

    }

    
  }


  selectedTabChangeOrganizational(traget) {

    if (traget.tab.textLabel == 'Update Progress') {
    } else if (traget.tab.textLabel == 'Set up') {
    }


  }

  selectedTabChangeProjectPlan(traget) {

    if (traget.tab.textLabel == 'Update Progress') {
      this.GetBaselineToBaseline();
    } else if (traget.tab.textLabel == 'Set up') {
      this.GetBaselineToSetUp();
    } else if (traget.tab.textLabel == 'Dashboard') {
      this.ganttchart.OnloadBaseline(false, this.SelectPlan);
      this.GetBaselineToBaseline();
      this.GetBaselineToSetUp();
    } else if (traget.tab.textLabel == 'Timeline') {
      this.ganttchart.OnloadBaseline(false, this.SelectPlan);
    }


  }



  LoadProjectList(auth_token): Observable<ProjectInfo[]> {
    //var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{\"ProjectCode\": \"" + this.checkUndefinedString(this._ParamProjectCode) + "\", " +

        "\"rowFetch\": " + environment.PageSize + ", " +
        "\"rowOFFSet\": " + offset + ", " +
        "\"FlagDelete\": \"N\" " +
        "}";

      return this.httpClient
        .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteriaProjectCO",
          strjson, httpOptions)
    }

  }
  async LoadStateList(cycleCode: string = "2"): Promise<StateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      var objectjson = {};
      objectjson['CycleCode'] = cycleCode
      objectjson['FlagActive'] = "Y"
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<StateInfo[]>(this.baseurl + "MasterSale/GetMappingStateStatusList", strjson, httpOptions)
        .toPromise()
    }
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
 

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

 

  clearSearchSection() {

   
  }


  // ---------------------- Project Document Detail Zone  -------------------------------
  LoadProjectDocumentList(): Observable<ProjectDocumentInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ProjectDocumentProjectID'] = this.hidProjectId;
      objectjson['FlagDelete'] = "N";



      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectDocumentInfo[]>(this.baseurl + "ProjectDocument/GetProjectDocument",
          strjson, httpOptions)

    }
  }


  LoadProjectDocument() {
    this.LoadProjectDocumentList()
      .subscribe({
        next: data => {
          this.ProjectDocumentList = data;
        },
        error: error => {
          console.error('There was an error!', error);
        }
      })
  }

  btnClick_deleteProjecDocument(id): Observable<ProjectDocumentInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectDocumentId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectDocumentInfo[]>(this.baseurl + "ProjectDocument/DeleteProjectDocument", strjsonCusInfo, httpOptions);
    }
  }


  btnClick_deleteProjectDocumentitem(id) {

    if (confirm("Are you sure you want to delete this item ?")) {
      this.btnClick_deleteProjecDocument(parseInt(id)).toPromise()
        .then(
          data => {
            console.log('หลังรับค่า');
            this.titlemodal = 'Delete Project Document done.';
            this.detailmodal = 'Your project document was deleted successfully.';

            $('#ModalComplate').modal();
            this.LoadProjectDocument();
          }
        );

    }

  }


  btnClick_onDeleteProjectDocumentList() {

    if (confirm("Are you sure you want to delete this Project?")) {

      var checkkedProjectDocument = $('[name="checkboxProjectDocument"]:checked');

      let num = checkkedProjectDocument.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectDocumentcurrent = <HTMLInputElement>checkkedProjectDocument[i];
        observableBatch.push(this.btnClick_deleteProjecDocument(parseInt(ProjectDocumentcurrent.value)).toPromise().then(val => {
        }));

      }

      Promise.all(observableBatch).then(val => {
        console.log('สำเร็จ');
        this.titlemodal = 'Delete Project Document done.';
        this.detailmodal = 'Your project document was deleted successfully.';

        $('#ModalComplate').modal();
        this.LoadProjectDocument();
      });

    }

  }

  // ---------------------- End Project Document Detail Zone  -------------------------------

  //// ---------------------- Event Detail Zone  -------------------------------
  //####### ย้ายไป Event Component ##########
  //// ---------------------- End Event Detail Zone  -------------------------------

  navigateToDownloadPO() {
    // Use window.location.href to navigate to the desired URL
    window.location.href = this.baseurl + 'ProjectDocument/downloadpofile?path=' + this.poOrderPathFile; // Replace with your target URL
  }

  navigateToDownloadWorkOrder() {
    // Use window.location.href to navigate to the desired URL
    window.location.href = this.baseurl + 'ProjectDocument/downloadpofile?path=' + this.workOrderPathFile; // Replace with your target URL
  }

  uploadFinished(traget) {
    this.InsertProjectDocument(traget.fileName, traget.dbPath);
  }

  async InsertProjectDocument(Filename , pathfile) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectDocumentProjectID'] = this.hidProjectId;
      objectjson['ProjectDocumentFileName'] = Filename;
      objectjson['ProjectDocumentPathFile'] = pathfile;
      objectjson['FlagDelete'] = "N";
      objectjson['CreateBy'] = this._EmpCode;



      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "ProjectDocument/InsertProjectDocument", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.LoadProjectDocument();
          }
        );
    }
  }

  CheckboxPlanOnChange() {
    var checkbaseline = this.inlineCheckboxBaselinePlan;
    if (checkbaseline == true) {
      this.SelectPlan += 'baseline,';
    } else {
      this.SelectPlan =  this.SelectPlan.replace(new RegExp('baseline,', 'g'), '');
    }
    var checkboxactual = this.inlineCheckboxActualPlan;
    if (checkboxactual == true) {
      this.SelectPlan += 'actual,';
    } else {
      this.SelectPlan = this.SelectPlan.replace(new RegExp('actual,', 'g'), '');
    }
    this.ganttchart.OnloadBaseline(false, this.SelectPlan);


  }


    // ---------------------- Project Plan  Zone  -------------------------------



  async loadDDLStage() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"PROJECTPALNSTAGE\" }";

      this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.Stagelist = data
        });
    }
  }

  async loadDDLPriorty() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson["LookupType"] = "PROJECTPALNPRIORTY"
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadDDLSupportContractType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      //objectjson["LookupType"] = "PROJECTSUPPORTCONTRACTTYPE"
      objectjson["LookupType"] = "PROJECTSUPPORTCONTRACTTYPE"
      let strjson = JSON.stringify(objectjson);
      
      return await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }

  async loadDDLProjectType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["LookupType"] = "PROJECTTYPE"
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }

  async loadDDLPackage() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{}";

      return await this.httpClient.post<any>(this.baseurl + "ProjectPackage/GetProjectPackage", strjson, httpOptions)
        .toPromise();
    }
  }


  async loadBaseline() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['BaselineProjectCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<BaselineInfo[]>(this.baseurl + "Baseline/GetBaseline", strjson, httpOptions)
        .toPromise()
    }
  }


  GetBaselineToBaseline() {
    this.loadBaseline().then((data) => {
      this.BaselineList = data;

      this.itemsBaseline = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;
      this.itemsBaseline.clear();

      this.BaselineList.forEach((traget, indextraget) => {
        var actionlist = JSON.parse(JSON.stringify(this.Actionlist));
        var actionindex = actionlist.findIndex(s => s.LookupCode == traget.BaselinePriorty);
        if (actionindex != -1) {
          actionlist[actionindex]['selected'] = true;
        }
        this.itemsBaseline.push(this.createItemBaseline(traget, actionlist));
      });

    });
  }

  async GetBaselineToSetUp() {
    this.loadBaseline().then(async (data) => {
      this.BaselineList = data;
      

      this.itemsSetup = await this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
      this.itemsSetup.clear();

      this.BaselineList.forEach((traget, indextraget) => {
        this.itemsSetup.push(this.createItemSetup(traget));
      });

    });
  }


  async btnClick_submitInsertProjectPlan() {
    if (this.ProjectDetailForm.get('SetupForm').valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.loading(true, 'Saving ...');
        var flagremove = null;
        //remove old data
        await this.RemoveoldProjectPlan().then((data) => {
          flagremove = data;
        });

        if (flagremove == true) {
          console.log('form submitted');
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          var listsetup = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
          var listsetupcontrols = listsetup.controls;
          var arrayinsert = [];
          listsetupcontrols.forEach((itemcurrent) => {
            var objectjson = {};
            objectjson['BaselineProjectCode'] = this._ParamProjectCode;
            objectjson['BaselineTaskName'] = itemcurrent.value.BaselineTaskName;
            objectjson['BaselineType'] = itemcurrent.value.BaselineType;
            objectjson['BaselineStartDate'] = itemcurrent.value.BaselineStartDate;
            objectjson['BaselineEndDate'] = itemcurrent.value.BaselineEndDate;
            objectjson['BaselineRemark'] = itemcurrent.value.BaselineRemark;
            objectjson['BaselineActualStartDate'] = this.checkUndefinedDate(itemcurrent.value.BaselineActualStartDate);
            objectjson['BaselineActualEndDate'] = this.checkUndefinedDate(itemcurrent.value.BaselineActualEndDate);
            objectjson['BaselinePriorty'] = itemcurrent.value.BaselinePriorty;
            objectjson['BaselineCreateBy'] = this.checkUndefinedString(this._EmpCode);
            objectjson['BaselineUpdateBy'] = this.checkUndefinedString(this._EmpCode);
            objectjson['BaselineProgress'] = itemcurrent.value.BaselineProgress;

            arrayinsert.push(objectjson);
          });



          let strjson = JSON.stringify(arrayinsert);

          this.isSubmitted = this.httpClient.post<any>(this.baseurl + "Baseline/InsertBaseline", strjson, httpOptions)

            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Insert fail")
              this.loading(false);

              this.titlemodal = 'Saving Project Plan fail.';
              this.detailmodal = 'Your project plan was saved fail.';
              $('#ModalError').modal();

            },
              () => {
                console.log("Insert = " + this.isSubmitted)
                this.loading(false);
                this.titlemodal = 'Saving Project Plan done.';
                this.detailmodal = 'Your project plan was updated successfully.';
                $('#ModalComplate').modal();
                console.log(this.ProjectCode);
                //this.selectedTabChange('Timeline & Project Plan');
                //this.ganttchart.OnloadBaseline(false, this.SelectPlan);
                //this.ngOnInit();
              }
            )
        } else {
          this.loading(false);

          this.titlemodal = 'Saving Project Plan fail.';
          this.detailmodal = 'Your project plan was saved fail.';
          $('#ModalError').modal();
          console.log('remove not complate')
        }

      }
    } else {
      this.markFormGroupTouched(this.ProjectDetailForm.get('SetupForm') as FormGroup);

    }
  }

  async btnClick_UpdateProjectPlan() {
    if (this.ProjectDetailForm.get('BaselineForm').valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form updatted');
        this.loading(true, 'Saving ...');

        console.log('form submitted');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var listbaseline = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;
        var listbaselinecontrols = listbaseline.controls;
        var arrayinsert = [];
        listbaselinecontrols.forEach((itemcurrent) => {
          var objectjson = {};
          objectjson['BaselineId'] = itemcurrent.value.BaselineId;
          objectjson['BaselineActualStartDate'] = this.checkUndefinedDate(itemcurrent.value.BaselineActualStartDate);
          objectjson['BaselineActualEndDate'] = this.checkUndefinedDate(itemcurrent.value.BaselineActualEndDate);
          objectjson['BaselinePriorty'] = this.checkUndefinedString(itemcurrent.value.selectaction);
          objectjson['BaselineCreateBy'] = this.checkUndefinedString(this._EmpCode);
          objectjson['BaselineUpdateBy'] = this.checkUndefinedString(this._EmpCode);

          objectjson['BaselineProgress'] = itemcurrent.value.BaselineProgress;

          arrayinsert.push(objectjson);
        });



        let strjson = JSON.stringify(arrayinsert);

        this.isSubmitted = this.httpClient.post<any>(this.baseurl + "Baseline/UpdateBaseline", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("update fail")
            this.loading(false);

            this.titlemodal = 'Saving Project Plan fail.';
            this.detailmodal = 'Your project plan was saved fail.';
            $('#ModalError').modal();

          },
            () => {
              console.log("update = " + this.isSubmitted)
              this.loading(false);
              this.titlemodal = 'Saving Project Plan done.';
              this.detailmodal = 'Your project plan was updated successfully.';

              $('#ModalComplate').modal();
              this.selectedTabChange('Timeline & Project Plan');
              this.ganttchart.OnloadBaseline(false, this.SelectPlan);
              //this.ganttchart.OnloadBaseline(false, this.SelectPlan);
            }
          )


      }
    } else {
      this.markFormGroupTouched(this.ProjectDetailForm.get('BaselineForm') as FormGroup);

    }
  }

  async RemoveoldProjectPlan() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"BaselineProjectCode\":\"" + this._ParamProjectCode + "\" }";

      return await this.httpClient.post<any>(this.baseurl + "Baseline/DeleteBaseline", strjson, httpOptions)
        .toPromise()
    }
  }

  createAction(actionInputs) {
    const arr = actionInputs.map(action => {
      return new FormControl(action.selected || false);
    });
    return new FormArray(arr);
  }

  SetSelectTabProject(tabCount:number) {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % tabCount;
  }

  SetSelectTabOrganizational(tabCount: number) {
    this.TabOrganizationalIndex = (this.TabOrganizationalIndex + 1) % tabCount;
  }

  OnClickSetUp() {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % 3;
  }

  OnClickBack() {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % 2;
  }


  validateData(): FormGroup {
    return this.formBuilder.group({
      txtPOOrderNo: ['', Validators.required],
      txtWorkOrderNo: ['', Validators.required]
    }
    );
  }



  createItemSetupDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      BaselineTaskName: ['', Validators.required],
      BaselineType: [null, Validators.required],
      BaselineStartDate: ['', Validators.required],
      BaselineEndDate: ['', Validators.required],
      BaselineRemark: [''],
      BaselineActualStartDate: [''],
      BaselineActualEndDate: [''],
      BaselinePriorty: [''],
      BaselineProgress:['']
    },
      {
        // Used custom form validator 
        validator: [this.checkdate("BaselineStartDate", "BaselineEndDate")]
      }
    );
  }

  // validate custom
  checkdate(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if (Date.parse(startcontrol.value) > Date.parse(endcontrol.value)) {
        endcontrol.setErrors({ checkdate: true });
      } else {
        endcontrol.setErrors(null);
      }
    };
  }

  // validate custom
  checkdateActual(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if ((startcontrol.value == '' || startcontrol.value == null) && endcontrol.value != null && endcontrol.value != "" ) {
        startcontrol.setErrors({ needstartdate: true });
        startcontrol.markAsTouched();
        endcontrol.markAsTouched();

      } else {
        startcontrol.setErrors(null);
      }
    };
  }


  checkdatecurrent(
    controlName: string,
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];

      if (startcontrol.errors && !startcontrol.errors.checkdatecurrent) {
        return;
      }

      if (Date.parse(new Date().toDateString()) > Date.parse(startcontrol.value)) {
        startcontrol.setErrors({ checkdatecurrent: true });
      } else {
        startcontrol.setErrors(null);
      }
    };
  }

  createItemSetup(baselineitem: BaselineInfo): FormGroup {
    
    return this.formBuilder.group({
      ProjectCode: [''],
      BaselineTaskName: [baselineitem.BaselineTaskName, Validators.required],
      BaselineType: [baselineitem.BaselineType, Validators.required],
      BaselineStartDate: [this.ConvertDatetoDatetime(baselineitem.BaselineStartDate), Validators.required],
      BaselineEndDate: [this.ConvertDatetoDatetime(baselineitem.BaselineEndDate), Validators.required],
      BaselineRemark: [baselineitem.BaselineRemark],
      BaselineActualStartDate: [this.ConvertDatetoDatetime(baselineitem.BaselineActualStartDate)],
      BaselineActualEndDate: [this.ConvertDatetoDatetime(baselineitem.BaselineActualEndDate)],
      BaselinePriorty: [baselineitem.BaselinePriorty],
      BaselineProgress: [baselineitem.BaselineProgress]
    },
      {
        // Used custom form validator 
        validator: [this.checkdate("BaselineStartDate", "BaselineEndDate")]
      }
    );
  }

  createItemBaselineDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      BaselineTaskName: [''],
      BaselineTaskNameDisplay: [''],
      BaselineType: [null],
      BaselineTypeDisplay: [''],
      BaselineStartDate: [''],
      BaselineEndDate: [''],
      BaselineRemark: [''],
      BaselineActualStartDate: [''],
      BaselineActualEndDate: [''],
      BaselinePriorty: [''],
      BaselineProgress: ['']
    },
      {
        // Used custom form validator 
        validator: [this.checkdateActual("BaselineActualStartDate", "BaselineActualEndDate"), this.checkdate("BaselineActualStartDate", "BaselineActualEndDate")]
      }
    );
  }

  createItemBaseline(baselineitem: BaselineInfo, actionlist): FormGroup {
    
    return this.formBuilder.group({
      ProjectCode: [''],
      BaselineId: [baselineitem.BaselineId],
      BaselineTaskName: [baselineitem.BaselineTaskName],
      BaselineTaskNameDisplay: [baselineitem.BaselineTaskNameDisplay],
      BaselineType: [baselineitem.BaselineType],
      BaselineTypeDisplay: [baselineitem.BaselineTypeDisplay],
      BaselineStartDate: [this.ConvertDatetoDatetime(baselineitem.BaselineStartDate)],
      BaselineEndDate: [this.ConvertDatetoDatetime(baselineitem.BaselineEndDate)],
      BaselineRemark: [baselineitem.BaselineRemark],
      BaselineActualStartDate: [this.ConvertDatetoDatetime(baselineitem.BaselineActualStartDate)],
      BaselineActualEndDate: [this.ConvertDatetoDatetime(baselineitem.BaselineActualEndDate)],
      BaselinePriorty: this.createAction(actionlist),
      selectaction: [baselineitem.BaselinePriorty],
      BaselineProgress: [baselineitem.BaselineProgress]
    },
      {
        // Used custom form validator 
        validator: [this.checkdateActual("BaselineActualStartDate", "BaselineActualEndDate"), this.checkdate("BaselineActualStartDate", "BaselineActualEndDate")]
      }
    );
  }

  addItem(): void {
    this.itemsSetup = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
    this.itemsSetup.push(this.createItemSetupDefault());
  }

  removeItem(indexitem): void {
    this.itemsSetup = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
    this.itemsSetup.removeAt(indexitem);
  }

  getvalueselect(traget, index) {
    this.itemsBaseline = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;

    var checked = traget.checked; // true mean cheked
    if (checked == true) {
      var indextraget = this.Actionlist.findIndex(x => x.LookupCode == traget.value);
      var Actionall = this.itemsBaseline.controls[index].value.BaselinePriorty;
      for (var i = 0; i < Actionall.length; i++) {
        if (i != indextraget) {
          var controlsgroup = this.itemsBaseline.controls[index] as FormGroup;
          var contraolarray = controlsgroup.controls.BaselinePriorty as FormArray;
          // set checkbox
          contraolarray.controls[i].setValue(false);
        }
      }
    } else {
      this.itemsBaseline.controls[index].value.selectaction = '';

    }


    var actionselect = this.itemsBaseline.controls[index].value.BaselinePriorty.findIndex(x => x == true);
    if (actionselect != -1) {
      this.itemsBaseline.controls[index].value.selectaction = this.Actionlist[actionselect].LookupCode;
    } else {
      this.itemsBaseline.controls[index].value.selectaction = '';

    }
  }

  // set end date = start date when select stage = Milestone
  BaselineStageChange(traget) {
    var current = traget.currentTarget;
    var currentselecttext = $(current).find('option:selected').text().trim();
    if (currentselecttext == 'Milestone') {
      var indexcontrol = $(current).attr('index');
      var FormArray = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
      var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

      if (controlsgroup.controls.BaselineStartDate.value != '' && controlsgroup.controls.BaselineStartDate.value != null) {
        controlsgroup.controls.BaselineEndDate.setValue(controlsgroup.controls.BaselineStartDate.value);
      }
    }
    

  }


    // set end date = start date when select stage = Milestone  (On start date change)
  BaselineStartDateChange(traget) {
    var current = traget.currentTarget;
    var indexcontrol = $(current).attr('index');
    var FormArray = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
    var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

    // if Base line Stage = Milestone
    if (controlsgroup.controls.BaselineType.value == '4') {
      if (controlsgroup.controls.BaselineStartDate.value != '' && controlsgroup.controls.BaselineStartDate.value != null) {
        controlsgroup.controls.BaselineEndDate.setValue(controlsgroup.controls.BaselineStartDate.value);
      }
    }

   


  }



  // set end date = start date when select stage = Milestone  (On start date change)
  BaselineActualStartDateChange(traget) {
    var current = traget.currentTarget;
    var indexcontrol = $(current).attr('index');
    var FormArray = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;
    var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

    // if Base line Stage = Milestone
    if (controlsgroup.controls.BaselineTypeDisplay.value == 'Milestone') {
      if (controlsgroup.controls.BaselineActualStartDate.value != '' && controlsgroup.controls.BaselineActualStartDate.value != null) {
        controlsgroup.controls.BaselineActualEndDate.setValue(controlsgroup.controls.BaselineActualStartDate.value);
      }
    }


  }


      // ---------------------- End Project Plan  Zone  -------------------------------

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  ConvertDatetoDatetime(DateValue) {
    if (DateValue) {
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
      ];
      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daydisplay = day.toString();
      if (day < 10) {
        daydisplay = '0' + day
      }

      var monthIndex = date.getMonth()+1;
      var monthisplay = monthIndex.toString();
      if (monthIndex < 10) {
        monthisplay = '0' + monthIndex
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();

      var Datenow = '';

      Datenow = year + "-" + monthisplay + "-" + daydisplay;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }

  isFieldValid(field: string) {
    return !this.ProjectDetailForm.get(field).valid && this.ProjectDetailForm.get(field).touched;
  }


  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }


  selectFileOnChange(ss) {

    var fileName = ss.currentTarget.files[0].name;
    this.filesToUpload = ss.currentTarget.files;
    $("#file").val(fileName);
    const reader = new FileReader();
    reader.onload = () => {
      this.pathImg = reader.result as string;
    }
    // read the image file as a data URL.
    reader.readAsDataURL(ss.currentTarget.files[0]);
    $('#previewImg').show();
  }

  selectFilePOOnChange(ss) {

    var fileName = ss.currentTarget.files[0].name;
    this.poFilesToUpload = ss.currentTarget.files;
    $("#filepo").val(fileName);
    
  }

  selectFileWorkOnChange(ss) {

    var fileName = ss.currentTarget.files[0].name;
    this.workorderFilesToUpload = ss.currentTarget.files;
    $("#filework").val(fileName);
  }

  btnClick_selectFile(traget, id: string) {
   
      var file = $(traget.currentTarget).parents().find(id);
      file.trigger("click");
    
  }

  // Add from lesson learned tab
  async loadProjectTimeDuration(blstartdate: string, blenddate: string, actstartdate: string, actenddate: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['BaselineStartDate'] = blstartdate;
      objectjson['BaselineEndDate'] = blenddate;
      objectjson['BaselineActualStartDate'] = actstartdate;
      objectjson['BaselineActualEndDate'] = actenddate;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<BaselineInfo[]>(this.baseurl + "Baseline/GetProjectTimeDuration", strjson, httpOptions)
        .toPromise()
    }
  }

  GetBaselineToLessonLearned() {
    this.loadBaseline().then((data) => {
      this.BaselineList = data;
      if (data.length > 0) {
        this.baselineListSortbybaselineId = this.BaselineList.sort((a, b) => a.BaselineId - b.BaselineId);

        this.lblbaselinestartdate = this.baselineListSortbybaselineId[0].BaselineStartDate;
        this.lblbaselineenddate = this.baselineListSortbybaselineId[this.baselineListSortbybaselineId.length - 1].BaselineEndDate;
        this.lblactualstartdate = this.baselineListSortbybaselineId[0].BaselineActualStartDate;
        this.lblactualenddate = this.baselineListSortbybaselineId[this.baselineListSortbybaselineId.length - 1].BaselineActualEndDate;

        this.loadProjectTimeDuration(this.lblbaselinestartdate, this.lblbaselineenddate, this.lblactualstartdate, this.lblactualenddate).then((data) => {
          this.BaselineTimeList = data;
          console.log(data);
          if (data.length > 0) {
            this.lblbaselinetotaldays = this.BaselineTimeList[0].BaselineDurationWork;
            this.lblactualtotaldays = this.BaselineTimeList[0].BaselineActualDurationWork;
            this.lbloverduedays = this.BaselineTimeList[0].BaselineActualOverdueWork;
          }
          if (this.lblactualenddate == null) {
            this.lblactualtotaldays = 0;
          }
          
        });
      } else {
        this.lblbaselinestartdate = null;
        this.lblbaselineenddate = null;
        this.lblactualstartdate = null;
        this.lblactualenddate = null;

        this.lblbaselinetotaldays = null;
        this.lblactualtotaldays = null;
        this.lbloverduedays = 0;
        this.lblactualtotaldays = 0;
      }
    });
  }

  chartClicked(traget) {

  }

  LoadIssueAll() {

    this.LoadIssueList(true)
      .then(
        data => {
          this.issueListAll = data;
          this.IssueSummaryTotal = data.filter(x => x.IssueStatusName != "Closed").length;
          this.summaryInfo.sumPriorityL = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Low").length;
          this.summaryInfo.sumPriorityM = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium").length;
          this.summaryInfo.sumPriorityH = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High").length;

          this.summaryInfo.sumSeverityL = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Minor").length;
          this.summaryInfo.sumSeverityM = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Major").length;
          this.summaryInfo.sumSeverityH = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Critical").length;

          this.summaryInfo.sumStatusOpen = data.filter(x => x.IssueStatusName == "Open").length;
          this.summaryInfo.sumStatusInprogress = data.filter(x => x.IssueStatusName == "In Progress").length;
          this.summaryInfo.sumStatusClosed = data.filter(x => x.IssueStatusName == "Closed").length;
          this.summaryInfo.sumStatusNew = data.filter(x => x.IssueStatusName == "New").length;
          this.summaryInfo.sumStatusHold = data.filter(x => x.IssueStatusName == "Hold").length;

          this.summaryInfo.PriorityLList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Low");
          this.summaryInfo.PriorityMList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium");
          this.summaryInfo.PriorityHList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High");
          this.summaryInfo.SeverityLList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Low");
          this.summaryInfo.SeverityMList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Medium");
          this.summaryInfo.SeverityHList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "High");
          this.pieChartLabels = ['Open', 'In Progress', 'Hold', 'Closed']
          this.pieChartData = [this.summaryInfo.sumStatusOpen, this.summaryInfo.sumStatusInprogress, this.summaryInfo.sumStatusHold, this.summaryInfo.sumStatusClosed];
          this.pieChartColors[0].backgroundColor = ['#6ae7d8', '#6a8fef', '#e8a362', '#5f5e5e'];

          this.totalticket = this.summaryInfo.sumStatusOpen + this.summaryInfo.sumStatusInprogress + this.summaryInfo.sumStatusHold + this.summaryInfo.sumStatusClosed
        }
    )    
  }

  async LoadIssueList(Getall: boolean = false): Promise<IssueInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      // Update variable for pagination from pagination control
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      objectjson['FlagDelete'] = "N";

      if (Getall == true) {
        objectjson['rowFetch'] = 0;
        objectjson['rowOFFSet'] = 0;

      }

      let strjson = JSON.stringify(objectjson);
      this.IssuePromise = this.httpClient
        .post<IssueInfo[]>(this.baseurl + "Issue/GetIssueCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.IssuePromise;
    }
  }

  GroupAndSumStatusIssue(list) {
    var result = [];
    list.reduce(function (res, value) {
      if (!res[value.IssueOwnerCode]) {
        res[value.IssueOwnerCode] = { ActionOwner: value.IssueOwnerName, IssueOwnerCode: value.IssueOwnerCode, IssueOwnerNickName: value.IssueOwnerNickName, IssueAmount: 0, PriorityHigh: 0, PriorityMedium: 0, PriorityLow: 0, SeverityHigh: 0, SeverityMedium: 0, SeverityLow: 0 };
        result.push(res[value.IssueOwnerCode])
      }
      res[value.IssueOwnerCode].IssueAmount += 1;

      if (value.PriorityCode == "1") {
        res[value.IssueOwnerCode].PriorityLow += 1;
      }
      if (value.PriorityCode == "2") {
        res[value.IssueOwnerCode].PriorityMedium += 1;
      }
      if (value.PriorityCode == "3") {
        res[value.IssueOwnerCode].PriorityHigh += 1;
      }
      if (value.SeverityCode == "1") {
        res[value.IssueOwnerCode].SeverityLow += 1;
      }
      if (value.SeverityCode == "2") {
        res[value.IssueOwnerCode].SeverityMedium += 1;
      }
      if (value.SeverityCode == "3") {
        res[value.IssueOwnerCode].SeverityHigh += 1;
      }
      return res;
    }, {});

    return result;
  }

  async SaveProjectComment() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectId'] = this.hidProjectId;
      objectjson['Comment'] = this.txtProjectComment;

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "Project/UpdateProject", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted)

            $('#ModalSaveCommentComplete').modal();
          }
        );
    }
  }

  // End Add from lesson learned tab
  OnClickConfirmSaveBaselineFile() {
    this.UploadFilesToServer(this.baselineFilesToUpload);
  }

  OnBtnClearClick() {
    $('#txtSchFileName').val('');
  }

  resetFileUploader() {
    this.fileUploader.nativeElement.value = null;
    this.pathImg == null;
      $('#previewImg').hide();

  }

  resetFilePOUploader() {
    this.filePOUploader.nativeElement.value = null;
    this.poFilesToUpload = null;
    this.poFileName = null;

  }

  resetFileWorkUploader() {
    this.fileWorkUploader.nativeElement.value = null;
    this.workorderFilesToUpload = null;
    this.workorderFileName = null;

  }

  /******************************* Upload file ********************************/
  DragFilesFinished(returnObj) {
    ;
    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.baselineFilesToUpload = returnObj.Files;
      this.baselinePathFile = returnObj.PathFile;
    }
  }

  UploadFilesToServer(files) {
    
    if (files.length === 0) {
      alert("Please browse file at least one.")
      return;
    }
    let filesToUpload: File[] = files;

    Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.baselinePathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
            }

          } else if (event.type === HttpEventType.Response) {

          }
        });


    });

  }
/******************************* Upload file ********************************/

/******************************* Event Upload file ********************************/
  async UploadEventFilesToServer(files) {
    
    if (!files || files.length === 0) {
      alert("Please browse file at least one.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.baselinePathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
              // check upload count
            }

          } else if (event.type === HttpEventType.Response) {

          }
        });



    });

    return true;
  }
/******************************* End Event Upload file ********************************/

/******************************* Po && Work Order Upload File ********************************/
  async UploadPOFilesToServer(files) {

    //if (!files || files.length === 0) {
    //  alert("Please browse file at least one.")
    //  return false;
    //}
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.poPathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
              // check upload count
            }

          } else if (event.type === HttpEventType.Response) {

          }
        });



    });

    return true;
  }


  // ----------------------- Function Assign Member Zone -----------------------------------------
  createItemAssignMemberDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [null],
      EmpName: [null, Validators.required],
      EmpNameDisplay: [null],
      PositionInProject: [null],
      PositionInProjectDisplay: [null],
      JobTitle: [null],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }

  createItemAssignMember(ProjectMemberitem: ProjectMemberInfo): FormGroup {
    return this.formBuilder.group({
      ProjectMemberId: [ProjectMemberitem.Id],
      EmpName: [ProjectMemberitem.EmpCode, Validators.required],
      EmpNameDisplay: [ProjectMemberitem.EmpNameDisplay],
      PositionInProject: [''],
      PositionInProjectDisplay: [''],
      JobTitle: [''],
      NickName: [''],
      Phone: [''],
      Email: [''],
      FlagRemove: [false]
    },
    );
  }


  async loadAssignMemberProject() {
    // clear old
    this.itemsAssignMemberForm_array.clear();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['ProjectType'] = 'Project';

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/GetProjectMember", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emp manager cuurent project
          var listempmanager = data.filter(function (obj) {
            return obj.PositionInProject == '1';
          });

          if (listempmanager.length) {
            this.EmpManager = listempmanager[0].EmpCode;
            this.EmpManagerDisplayName = listempmanager[0].EmpNameDisplay;
          }

          // Remove Lookup Project Manager from data on object property LookupCode = 1
          data = data.filter(function (obj) {
            return obj.PositionInProject !== '1';
          });
         

          this.AssignMemberLeadList = data;

          // if not empty Assign Member set default and Current User is Manager
          if (this.AssignMemberLeadList.length <= 0 && this.IsShowForThisManager == true) {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
          }

        });
    }
  }

  async loadEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteriaNotResign", strjson, httpOptions)
        .toPromise().then((data) => {

          // get emplist for assign member without cuurent manager && member is internal
          this.EmployeeList = data.filter(obj => {
            return obj.EmpCode !== this.EmpManager;// && obj.EmpType == '1';
          });

          // load detail emp for assign member

          this.AssignMemberLeadList.forEach((traget, indextraget) => {
            this.itemsAssignMemberForm_array.push(this.createItemAssignMember(traget));
            //load detail of Emp
            this.onChanges(indextraget)
          });
        });
    }
  }

  addAssignMemberItem(): void {
    this.itemsAssignMemberForm_array.push(this.createItemAssignMemberDefault());
  }

  removeAssignMemberItem(indexitem): void {
    // get id cuurent AssignMember
    var cuurentIdAssignMember = this.itemsAssignMemberForm_array.at(indexitem).value.ProjectMemberId;

    if (cuurentIdAssignMember != null) {
      // set FlagRemove Assign Member
      this.itemsAssignMemberForm_array.at(indexitem).value.FlagRemove = true;
    } else {
      // remove from Array
      this.itemsAssignMemberForm_array.removeAt(indexitem);
    }


  }

  // get count remove Assign Member for Display No.
  getcountremove() {
    return this.itemsAssignMemberForm_array.controls.filter(function (obj) {
      return obj.value.FlagRemove === true;
    }).length;
  }

  async onChanges(idx, checkForDuplicate: boolean = false, loadFromModal: boolean = false) {
    //this.selectEmpName = empcode;
    let empcode = '';
    let empselectbox = this.itemsAssignMemberForm_array.controls[idx].get('EmpName');

    if (loadFromModal) {
      empcode = this.selectedemp.EmpCode;
    } else {
      empcode = this.itemsAssignMemberForm_array.controls[idx].get('EmpName').value;
    }

    var duplicate: boolean = false;
    if (checkForDuplicate) {
      var listcontrols = this.itemsAssignMemberForm_array.controls;
      listcontrols.forEach((itemcurrent, index) => {
        if (itemcurrent.value.EmpName == empcode && index != idx) {
          duplicate = true;
        }
      });

    }


    if (!duplicate) {
      var jobtitle = this.EmployeeList.find(x => { return x.EmpCode == empcode }).JobTitle;
      var position = this.EmployeeList.find(x => { return x.EmpCode == empcode }).PositionName;
      var nickname = this.EmployeeList.find(x => { return x.EmpCode == empcode }).NickName;
      var mobile = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mobile;
      var mails = this.EmployeeList.find(x => { return x.EmpCode == empcode }).Mail;
      //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionCode;
      //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionName;

      var EmpJobTitle = this.itemsAssignMemberForm_array.controls[idx].get('JobTitle');
      var EmpPosition = this.itemsAssignMemberForm_array.controls[idx].get('PositionInProjectDisplay');
      var EmpNickname = this.itemsAssignMemberForm_array.controls[idx].get('NickName');
      var EmpPhone = this.itemsAssignMemberForm_array.controls[idx].get('Phone');
      var EmpMail = this.itemsAssignMemberForm_array.controls[idx].get('Email');

      EmpJobTitle.setValue(jobtitle);
      EmpPosition.setValue(position);
      EmpNickname.setValue(nickname)
      EmpPhone.setValue(mobile)
      EmpMail.setValue(mails)

      if (loadFromModal) {
        // console.log(this.EmployeeList)
        // console.log(empcode)
        let code = this.EmployeeList.find(x => { return x.EmpCode == empcode }).EmpCode;

        empselectbox.setValue(code);
      } 
    } else {
      this.removeAssignMemberItem(idx);
      this.addAssignMemberItem();
      alert("You cannnot select duplicate employee.");
    }
  }


  async ReLoadAssignMember() {
    // set to default
    this.AssignMemberForm.markAsUntouched();

    // ------------------- Assign Member Zone -------------------------------
    // Load Assgin Member
    await this.loadAssignMemberProject();
    // Load Emp List for Assign Member
    await this.loadEmpList();
    //Load PositionInProject (Lookup MASTERPROJECTROLE) for Assgin Member
    await this.GlobalService.loadLookup('MASTERPROJECTROLE').then((data) => {
      // Remove Lookup Project Manager from data on object property LookupCode = 1
      data = data.filter(function (obj) {
        return obj.LookupCode !== '1';
      });

      this.PositionInProjectList = data;
    });

 
    // ------------------- Assign Member Zone -------------------------------
  }

    //---------------------Project Cost event and function--------------------------------------
      async LoadProjectDeliveryCost() {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          this.LoadProjectDeliveryCostList(auth_token)
    
            .subscribe({
              next: data => {
                this.ProjectDeliveryCostList = data;
                this.hidcouchk = this.ProjectDeliveryCostList.length.toString();
              },
              error: error => {
                console.error('There was an error!', error);
              }
            });
        }
      }
    
      LoadProjectDeliveryCostList(auth_token): Observable<ProjectDeliveryCostInfo[]> {
    
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
    
        this.currentPageProjectDeliveryCostNumber = this.currentPageProjectDeliveryCostNumber > 0 ? this.currentPageProjectDeliveryCostNumber : 1;
        let offset = (this.currentPageProjectDeliveryCostNumber - 1) * environment.PageSize;
    
        var objectjson = {};
        objectjson['ProjectDeliveryID'] = this._ParamProjectDeliveryID;
        objectjson['FlagDelete'] = "N";
        objectjson['rowFetch'] = environment.PageSize;
        objectjson['rowOFFSet'] = offset;
        objectjson['ProjectDeliveryCostCode'] = this._ParamProjectCode;
    
    
        let strjson = JSON.stringify(objectjson);
    
        return this.httpClient
          .post<ProjectDeliveryCostInfo[]>(this.baseurl + "ProjectDeliveryCost/GetProjectDeliveryCost",
            strjson, httpOptions)
    
      }
    
      OnLoadCountProjectDeliveryCostList() {
        //call function load count all ticket list on hand current role user
        this.LoadCountProjectDeliveryCostList()
      }
    
      async LoadCountProjectDeliveryCostList() {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
    
          var objectjson = {};
          objectjson['ProjectDeliveryID'] = this._ParamProjectDeliveryID;
          objectjson['FlagDelete'] = "N";
    
          let strjson = JSON.stringify(objectjson);
          this.httpClient.post<number>(this.baseurl + "ProjectDeliveryCost/GetCountProjectDeliveryCost", strjson, httpOptions)
            .toPromise()
            .then(data => {
              this.ProjectDeliveryCostTotal = data;
              this.totalProjectDeliveryCostPages = Math.ceil(this.ProjectDeliveryCostTotal / environment.PageSize);
    
              if (data == 0) {
                this.currentPageProjectDeliveryCostNumber = 0;
              }
            })
        }
      }
    
      async OnLoadProjectDeliveryCostList(traget = null) {
    
        if (traget != null) { // check call function from change page or onloadfrist
          this.LoadProjectDeliveryCostUpdatePagination(traget);
        }
    
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          this.LoadProjectDeliveryCostList(auth_token).subscribe(data => { //call function load ticket list on hand current role user
            this.ProjectDeliveryCostList = data;
          })
        }
      }
    
      LoadProjectDeliveryCostUpdatePagination(traget) {
        this.currentPageProjectDeliveryCostNumber = traget.currentPageNumber;
        this.totalProjectDeliveryCostPages = traget.totalPages;
      }
    
      chkallProjectDeliveryCostclick(traget) {
        var check = $(traget.currentTarget).is(":checked");
    
        $('[name="checkboxProjectDeliveryCost"]').prop('checked', check);
    
      }
    
      btnClick_onCreateProjectDeliveryCost() {
        this.IsClearProjectDeliveryCostAttachedmentList = "false";
        $('#ModalProjectDeliveryCost').modal('show');
        this.txtProjectDeliveryCostItemCode = "";
        // this.txtProjectDeliveryCostItemName = "";
        this.txtProjectDeliveryCostType = "";
        this.txtProjectDeliveryCostQuantity = 0;
        this.txtProjectDeliveryCostUnit = "";
        this.txtProjectDeliveryCostUnitCost = 0;
        this.txtProjectDeliveryCostAmount = 0;
        this.ProjectDeliveryCostAttachedmentList = [];
        this.isOnUpdate = false;
    
        this.validatetxtProjectDeliveryCostItemCode = 'False';
        // this.validatetxtProjectDeliveryCostItemName = 'False';
        this.validatetxtProjectDeliveryCostType = 'False';
        this.validatetxtProjectDeliveryCostQuantity = 'False';
        this.validatetxtProjectDeliveryCostUnitCost = 'False';
      }
    
      DragFilesProjectCostAttachedmentFinished(returnObj) {
    
        if (!!returnObj.Message) {
          alert(returnObj.Message)
        } else {
          this.projectdeliveryCostFilesToUpload = returnObj.Files;
          this.projectdeliveryCostPathFile = returnObj.PathFile;
        }
      }
    
      CalculateAmount() {
        this.txtProjectDeliveryCostAmount = this.txtProjectDeliveryCostQuantity * this.txtProjectDeliveryCostUnitCost;
      }
    
      async btnClick_submitInsertProjectDeliveryCost() {
        this.ValidateInsertProjectDeliveryCost();
    
        // if (this.validatetxtProjectDeliveryCostItemCode == 'True' || this.validatetxtProjectDeliveryCostItemName == 'True' || this.validatetxtProjectDeliveryCostType == 'True' || this.validatetxtProjectDeliveryCostQuantity == 'True' || this.validatetxtProjectDeliveryCostUnitCost == 'True') {
        //   return;
        // }
        if (this.validatetxtProjectDeliveryCostItemCode == 'True' || this.validatetxtProjectDeliveryCostType == 'True' || this.validatetxtProjectDeliveryCostQuantity == 'True' || this.validatetxtProjectDeliveryCostUnitCost == 'True') {
          return;
        }
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
    
          var objectjson = {};
          // objectjson['ProjectDeliveryID'] = this._ParamProjectDeliveryID;
           objectjson['ProjectDeliveryID'] =  this.hidProjectId;
          // console.log("ProjectDeliveryID = " + this._ParamProjectDeliveryID + "this.hidProjectId" + this.hidProjectId);
          objectjson['ProjectDeliveryCostItemCode'] = this.checkUndefinedString(this.txtProjectDeliveryCostItemCode);
          // objectjson['ProjectDeliveryCostItemName'] = this.checkUndefinedString(this.txtProjectDeliveryCostItemName);
          // objectjson['ProjectDeliveryCostType'] = this.checkUndefinedString(this.txtProjectDeliveryCostType);
    
          if (this.txtProjectDeliveryCostQuantity == null || this.txtProjectDeliveryCostQuantity.toString() == "") {
            objectjson['ProjectDeliveryCostQuantity'] = 0;
          } else {
            objectjson['ProjectDeliveryCostQuantity'] = this.txtProjectDeliveryCostQuantity;
          }
    
          objectjson['ProjectDeliveryCostUnit'] = this.checkUndefinedString(this.txtProjectDeliveryCostUnit);
    
          if (this.txtProjectDeliveryCostUnitCost == null || this.txtProjectDeliveryCostUnitCost.toString() == "") {
            objectjson['ProjectDeliveryCostUnitCost'] = 0;
          } else {
            objectjson['ProjectDeliveryCostUnitCost'] = this.txtProjectDeliveryCostUnitCost;
          }
    
          if (this.txtProjectDeliveryCostAmount == null || this.txtProjectDeliveryCostAmount.toString() == "") {
            objectjson['ProjectDeliveryCostAmount'] = 0;
          } else {
            objectjson['ProjectDeliveryCostAmount'] = this.txtProjectDeliveryCostAmount;
          }
    
          objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          objectjson['FlagDelete'] = "N";
    
          let strjson = JSON.stringify(objectjson);
    
          this.isSubmitted = this.httpClient.post<ProjectDeliveryCostInfo[]>(this.baseurl + "ProjectDeliveryCost/InsertProjectDeliveryCost", strjson, httpOptions)
            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Insert fail")
            },
              async () => {
                console.log("Insert = " + this.isSubmitted)
    
                this.OnCreating('n');
    
                if (!!this.projectdeliveryCostFilesToUpload && this.projectdeliveryCostFilesToUpload.length > 0) {
                  var isUploadSaleCostAttachedSuccess = await this.UploadProjectDeliveryCostAttachedFileToServer(this.projectdeliveryCostFilesToUpload)
                  if (isUploadSaleCostAttachedSuccess) {
                    for (const val of this.projectdeliveryCostFilesToUpload) {
                      await this.InsertProjectDeliveryCostAttachedment(val.name, this.projectdeliveryCostPathFile + "\\" + val.name, this.isSubmitted)
                    }
                    $('#ModalProjectDeliveryCostCreateComplete').modal();
                    this.IsClearProjectDeliveryCostAttachedmentList = "true";
                    this.projectdeliveryCostFilesToUpload = [];
                    this.OnCreating('n');
                    this.LoadProjectDeliveryCost();
                    this.LoadProjectDeliveryCostAttachedment(this.isSubmitted);
                    this.OnLoadCountProjectDeliveryCostList();
                  }
                }
                else {
                  this.LoadProjectDeliveryCost();
                  this.LoadProjectDeliveryCostAttachedment(this.isSubmitted);
                  this.OnLoadCountProjectDeliveryCostList();
                  this.IsClearProjectDeliveryCostAttachedmentList = "false";
                  this.projectdeliveryCostFilesToUpload = [];
                  this.OnCreating('n');
                  $('#ModalProjectDeliveryCostCreateComplete').modal();
                }
              }
            )
        }
      }
    
      ValidateInsertProjectDeliveryCost() {
        if (this.txtProjectDeliveryCostItemCode == "" || this.txtProjectDeliveryCostItemCode == null) {
          this.validatetxtProjectDeliveryCostItemCode = 'True';
        } else {
          this.validatetxtProjectDeliveryCostItemCode = 'False';
        }
    
        // if (this.txtProjectDeliveryCostItemName == "" || this.txtProjectDeliveryCostItemName == null) {
        //   this.validatetxtProjectDeliveryCostItemName = 'True';
        // } else {
        //   this.validatetxtProjectDeliveryCostItemName = 'False';
        // }
    
        if (this.txtProjectDeliveryCostType == "" || this.txtProjectDeliveryCostType == null) {
          this.validatetxtProjectDeliveryCostType = 'True';
        } else {
          this.validatetxtProjectDeliveryCostType = 'False';
        }
    
        // if (this.txtProjectDeliveryCostQuantity.toString() == "" || this.txtProjectDeliveryCostQuantity == null || this.txtProjectDeliveryCostQuantity < 0) {
        //   this.validatetxtProjectDeliveryCostQuantity = 'True';
        // } else {
        //   this.validatetxtProjectDeliveryCostQuantity = 'False';
        // }
    
        // if (this.txtProjectDeliveryCostUnitCost.toString() == "" || this.txtProjectDeliveryCostUnitCost == null || this.txtProjectDeliveryCostUnitCost < 0) {
        //   this.validatetxtProjectDeliveryCostUnitCost = 'True';
        // } else {
        //   this.validatetxtProjectDeliveryCostUnitCost = 'False';
        // }
        let quantity = this.txtProjectDeliveryCostQuantity;
        if (quantity == null || isNaN(Number(quantity)) || Number(quantity) < 0) {
          this.validatetxtProjectDeliveryCostQuantity = 'True';
        } else {
          this.validatetxtProjectDeliveryCostQuantity = 'False';
        }

        let unitCost = this.txtProjectDeliveryCostUnitCost;
        if (unitCost == null || isNaN(Number(quantity)) || Number(unitCost) < 0) {
          this.validatetxtProjectDeliveryCostUnitCost = 'True';
        } else {
          this.validatetxtProjectDeliveryCostUnitCost = 'False';
        }

      }

    OnCreating(flag) {
    if (flag == 'y') {
    } else if (flag == 'n') {
      $('#ModalProjectDeliveryCost').modal('hide');
    }
  }
    
      async UploadProjectDeliveryCostAttachedFileToServer(files) {
    
        if (!files || files.length === 0) {
          alert("Please browse file at least one.")
          return false;
        }
        let filesToUpload: File[] = files;
    
        await Array.from(filesToUpload).map((file, index) => {
          // push uoload list
          const formData = new FormData();
          formData.append("pathfile", this.projectdeliveryCostPathFile);
          formData.append('file' + index, file, file.name);
          this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
            .subscribe(event => {
              if (event.type === HttpEventType.UploadProgress) {
                var progress = Math.round(100 * event.loaded / event.total);
    
                if (progress == 100) {
    
                }
    
              } else if (event.type === HttpEventType.Response) {
              }
            });
    
    
    
        });
    
        return true;
      }
    
      async InsertProjectDeliveryCostAttachedment(Filename, pathfile, projectdeliverycostid) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
    
          var objectjson = {};
          objectjson['ProjectDeliveryCostID'] = projectdeliverycostid;
          objectjson['ProjectDeliveryCostAttachedmentFileName'] = Filename;
          objectjson['ProjectDeliveryCostAttachedmentPathFile'] = pathfile;
          objectjson['FlagDelete'] = "N";
          objectjson['CreateBy'] = localStorage.getItem("EmpCode");
    
    
    
    
          let strjson = JSON.stringify(objectjson);
    
          this.isProjectDeliveryCostAttachedmentSubmitted = this.httpClient.post<ProjectDeliveryCostAttachedmentInfo[]>(this.baseurl + "ProjectDeliveryCostAttachedment/InsertProjectDeliveryCostAttachedment", strjson, httpOptions)
    
            .subscribe(result => this.isProjectDeliveryCostAttachedmentSubmitted = result, failCb => {
              console.log("Insert fail")
            },
              () => {
                console.log("Insert = " + this.isProjectDeliveryCostAttachedmentSubmitted)
              }
            )
        }
      }
    
      async LoadProjectDeliveryCostAttachedment(projectdeliverycostid) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          this.LoadProjectDeliveryCostAttachedmentList(projectdeliverycostid, auth_token)
            .subscribe({
              next: data => {
                this.ProjectDeliveryCostAttachedmentList = data;
              },
              error: error => {
                console.error('There was an error!', error);
              }
            });
        }
      }
    
      LoadProjectDeliveryCostAttachedmentList(projectdeliverycostid, auth_token): Observable<ProjectDeliveryCostAttachedmentInfo[]> {
    
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
    
        var objectjson = {};
    
    
        objectjson['ProjectDeliveryCostID'] = projectdeliverycostid;
        objectjson['FlagDelete'] = "N";
    
        let strjson = JSON.stringify(objectjson);
        return this.httpClient
          .post<ProjectDeliveryCostAttachedmentInfo[]>(this.baseurl + "ProjectDeliveryCostAttachedment/GetProjectDeliveryCostAttachedment",
            strjson, httpOptions)
    
      }
    
      async btnClick_onDeleteProjectDeliveryCostList() {
    
        if (confirm("Are you sure you want to delete this Sale Cost?")) {
    
          var checkboxProjectDeliveryCost = $('[name="checkboxProjectDeliveryCost"]:checked');
    
          let num = checkboxProjectDeliveryCost.length;
          let observableBatch = [];
          let observableBatch1 = [];
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            for (var i = 0; i < num; i++) {
    
              var ProjectDeliveryCostcurrent = <HTMLInputElement>checkboxProjectDeliveryCost[i];
              observableBatch.push(this.btnClick_deleteProjectDeliveryCost(parseInt(ProjectDeliveryCostcurrent.value), auth_token).toPromise().then(val => {
              }));
    
              var ProjectDeliveryCostAttachedmentcurrent = <HTMLInputElement>checkboxProjectDeliveryCost[i];
              observableBatch1.push(this.btnClick_deleteProjectDeliveryCostAttachedmentbyProjectDeliveryCostID(parseInt(ProjectDeliveryCostcurrent.value), auth_token).toPromise().then(val => {
              }));
    
            }
    
            Promise.all(observableBatch).then(val => {
              console.log('สำเร็จ');
              $('#ModalDeleteProjectDeliveryBudgetComplete').modal('show');
              this.LoadProjectDeliveryCost();
              this.OnLoadCountProjectDeliveryCostList();
            });
          }
    
        }
    
      }
    
      btnClick_deleteProjectDeliveryCost(id, auth_token): Observable<ProjectDeliveryCostInfo[]> {
    
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var objectjson = {};
        objectjson['ProjectDeliveryCostID'] = id;
    
        let strjsonCusInfo = JSON.stringify(objectjson);
    
        return this.httpClient.post<ProjectDeliveryCostInfo[]>(this.baseurl + "ProjectDeliveryCost/DeleteProjectDeliveryCost", strjsonCusInfo, httpOptions);
    
      }
    
      btnClick_deleteProjectDeliveryCostAttachedmentbyProjectDeliveryCostID(id, auth_token): Observable<ProjectDeliveryCostAttachedmentInfo[]> {
    
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var objectjson = {};
        objectjson['ProjectDeliveryCostID'] = id;
    
        let strjsonCusInfo = JSON.stringify(objectjson);
    
        return this.httpClient.post<ProjectDeliveryCostAttachedmentInfo[]>(this.baseurl + "ProjectDeliveryCostAttachedment/DeleteProjectDeliveryCostAttachedmentbyProjectCostID", strjsonCusInfo, httpOptions);
      }
    
    
      async btn_LoadProjectDeliveryCostAttachedment(id) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          this.LoadProjectDeliveryCostAttachedmentList(id, auth_token)
            .subscribe({
              next: data => {
                this.ProjectDeliveryCostAttachedmentList = data;
                $('#modalProjectDeliveryCostAttachedment').modal('show');
              },
              error: error => {
                console.error('There was an error!', error);
              }
            });
        }
      }
    
      OnDeleteProjectDeliveryCostAttachedmentClick(elem) {
        let dataInfo = $(elem).parent().data();
        if (Object.keys(dataInfo).length > 0) {
          //Confirm to delete
          this.modalDocInfo = dataInfo;
          this.modalDocName = dataInfo.documentname;
          $('#ModalConfirmDeleteProjectDeliveryCostAttachedment').modal();
        }
      }
    
      async DeleteProjectDeliveryCostAttachedment() {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
    
          let offset = (this.currentPageProjectDeliveryCostNumber - 1) * environment.PageSize;
    
          var objectjson = {};
          objectjson['ProjectDeliveryCostAttachedmentID'] = this.modalDocInfo.documentid;
    
          let strjson = JSON.stringify(objectjson);
          this.httpClient
            .post<boolean>(this.baseurl + "ProjectDeliveryCostAttachedment/DeleteProjectDeliveryCostAttachedment",
              strjson, httpOptions)
            .subscribe({
              next: data => {
                if (data) {
                  this.titlemodal = "Success";
                  this.detailmodal = "The attached file has been deleted."
                  this.LoadProjectDeliveryCostAttachedment(this.hidprojectdeliverycostId);
                } else {
                  this.titlemodal = "Sorry";
                  this.detailmodal = "Delete fail."
                }
              },
              error: error => {
                console.error('There was an error!', error);
              }
            })
        }
      }
    
      async btnClick_deleteProjectDeliveryCostitem(id) {
    
        if (confirm("Are you sure you want to delete this Sale Cost ?")) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            this.btnClick_deleteProjectDeliveryCost(parseInt(id), auth_token).toPromise()
              .then(
                data => {
                  console.log('หลังรับค่า');
                  $('#ModalDeleteProjectDeliveryCostComplete').modal('show');
                  this.LoadProjectDeliveryCost();
                  this.OnLoadCountProjectDeliveryCostList();
                }
              );
    
          }
        }
    
      }
    
      btnClick_onUpdateProjectDeliveryCost(id) {
        this.isOnUpdate = true;
        this.IsClearProjectDeliveryCostAttachedmentList = "false";
    
        this.validatetxtProjectDeliveryCostItemCode = 'False';
        // this.validatetxtProjectDeliveryCostItemName = 'False';
        this.validatetxtProjectDeliveryCostType = 'False';
        this.validatetxtProjectDeliveryCostQuantity = 'False';
        this.validatetxtProjectDeliveryCostUnitCost = 'False';
    
        let index = this.ProjectDeliveryCostList.findIndex(x => x.ProjectDeliveryCostID == id);
    
        this.txtProjectDeliveryCostItemCode = this.ProjectDeliveryCostList[index].ProjectDeliveryCostItemCode != null ? this.ProjectDeliveryCostList[index].ProjectDeliveryCostItemCode : null
        // this.txtProjectDeliveryCostItemName = this.ProjectDeliveryCostList[index].ProjectDeliveryCostItemName != null ? this.ProjectDeliveryCostList[index].ProjectDeliveryCostItemName : null
        this.txtProjectDeliveryCostType = this.ProjectDeliveryCostList[index].ProjectDeliveryCostTypeName != null ? this.ProjectDeliveryCostList[index].ProjectDeliveryCostTypeName : null
        this.txtProjectDeliveryCostQuantity = this.ProjectDeliveryCostList[index].ProjectDeliveryCostQuantity != null ? this.ProjectDeliveryCostList[index].ProjectDeliveryCostQuantity : null
        this.txtProjectDeliveryCostUnit = this.ProjectDeliveryCostList[index].ProjectDeliveryCostUnit != null ? this.ProjectDeliveryCostList[index].ProjectDeliveryCostUnit : null
        this.txtProjectDeliveryCostUnitCost = this.ProjectDeliveryCostList[index].ProjectDeliveryCostUnitCost != null ? this.ProjectDeliveryCostList[index].ProjectDeliveryCostUnitCost : null
        this.txtProjectDeliveryCostAmount = this.ProjectDeliveryCostList[index].ProjectDeliveryCostAmount != null ? this.ProjectDeliveryCostList[index].ProjectDeliveryCostAmount : null
        this.hidprojectdeliverycostId = this.ProjectDeliveryCostList[index].ProjectDeliveryCostID;
    
        this.LoadProjectDeliveryCostAttachedment(id);
    
        $('#ModalProjectDeliveryCost').modal();
      }
    
      async btnClick_submitUpdateProjectDeliveryCost() {
        this.ValidateInsertProjectDeliveryCost();
    
        // if (this.validatetxtProjectDeliveryCostItemCode == 'True' || this.validatetxtProjectDeliveryCostItemName == 'True' || this.validatetxtProjectDeliveryCostType == 'True' || this.validatetxtProjectDeliveryCostQuantity == 'True' || this.validatetxtProjectDeliveryCostUnitCost == 'True') {
        //   return;
        // }
        console.log("validatetxtProjectDeliveryCostItemCode = " + this.validatetxtProjectDeliveryCostItemCode);
        console.log("validatetxtProjectDeliveryCostType = " + this.validatetxtProjectDeliveryCostType);
        console.log("validatetxtProjectDeliveryCostQuantity = " + this.validatetxtProjectDeliveryCostQuantity);
        console.log("validatetxtProjectDeliveryCostUnitCost = " + this.validatetxtProjectDeliveryCostUnitCost);

        if (this.validatetxtProjectDeliveryCostItemCode == 'True'  || this.validatetxtProjectDeliveryCostType == 'True' || this.validatetxtProjectDeliveryCostQuantity == 'True' || this.validatetxtProjectDeliveryCostUnitCost == 'True') {
          return;
        }
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
    
          var objectjson = {};
          objectjson['ProjectDeliveryCostID'] = this.hidprojectdeliverycostId;
          objectjson['ProjectDeliveryID'] = this._ParamProjectDeliveryID;
          objectjson['ProjectDeliveryCostItemCode'] = this.checkUndefinedString(this.txtProjectDeliveryCostItemCode);
          // objectjson['ProjectDeliveryCostItemName'] = this.checkUndefinedString(this.txtProjectDeliveryCostItemName);
          // objectjson['ProjectDeliveryCostType'] = this.checkUndefinedString(this.txtProjectDeliveryCostType);
    
          if (this.txtProjectDeliveryCostQuantity == null || this.txtProjectDeliveryCostQuantity.toString() == "") {
            objectjson['ProjectDeliveryCostQuantity'] = 0;
          } else {
            objectjson['ProjectDeliveryCostQuantity'] = this.txtProjectDeliveryCostQuantity;
          }
    
          objectjson['ProjectDeliveryCostUnit'] = this.checkUndefinedString(this.txtProjectDeliveryCostUnit);
    
          if (this.txtProjectDeliveryCostUnitCost == null || this.txtProjectDeliveryCostUnitCost.toString() == "") {
            objectjson['ProjectDeliveryCostUnitCost'] = 0;
          } else {
            objectjson['ProjectDeliveryCostUnitCost'] = this.txtProjectDeliveryCostUnitCost;
          }
    
          if (this.txtProjectDeliveryCostAmount == null || this.txtProjectDeliveryCostAmount.toString() == "") {
            objectjson['ProjectDeliveryCostAmount'] = 0;
          } else {
            objectjson['ProjectDeliveryCostAmount'] = this.txtProjectDeliveryCostAmount;
          }
    
          objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          objectjson['FlagDelete'] = "N";
    
          let strjson = JSON.stringify(objectjson);
    
          this.isSubmitted = this.httpClient.post<ProjectDeliveryCostInfo[]>(this.baseurl + "ProjectDeliveryCost/UpdateProjectDeliveryCost", strjson, httpOptions)
            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Update fail")
            },
              async () => {
                console.log("Insert = " + this.isSubmitted)
    
                this.OnCreating('n');
    
                if (!!this.projectdeliveryCostFilesToUpload && this.projectdeliveryCostFilesToUpload.length > 0) {
                  var isUploadSaleCostAttachedSuccess = await this.UploadProjectDeliveryCostAttachedFileToServer(this.projectdeliveryCostFilesToUpload)
                  if (isUploadSaleCostAttachedSuccess) {
                    for (const val of this.projectdeliveryCostFilesToUpload) {
                      await this.InsertProjectDeliveryCostAttachedment(val.name, this.projectdeliveryCostPathFile + "\\" + val.name, this.isSubmitted)
                    }
                    $('#ModalProjectDeliveryCostCreateComplete').modal();
                    this.IsClearProjectDeliveryCostAttachedmentList = "true";
                    this.projectdeliveryCostFilesToUpload = [];
                    this.OnCreating('n');
                    this.LoadProjectDeliveryCost();
                    this.LoadProjectDeliveryCostAttachedment(this.isSubmitted);
                    this.OnLoadCountProjectDeliveryCostList();
                  }
                }
                else {
                  $('#ModalProjectDeliveryCostCreateComplete').modal();
                  this.IsClearProjectDeliveryCostAttachedmentList = "false";
                  this.projectdeliveryCostFilesToUpload = [];
                  this.OnCreating('n');
                  this.LoadProjectDeliveryCost();
                  this.LoadProjectDeliveryCostAttachedment(this.isSubmitted);
                  this.OnLoadCountProjectDeliveryCostList();
                }
              }
            )
        }
      }
  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }
     //---------------------Project Cost--------------------------------------
  async btnClick_submitSaveAssignMember() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      if (this.AssignMemberForm.valid) {
        console.log('SaveAssignMember submitted');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var listcontrols = this.itemsAssignMemberForm_array.controls;
        var arrayinsert = [];
        listcontrols.forEach((itemcurrent) => {
          var objectjson = {};

          objectjson['Id'] = itemcurrent.value.ProjectMemberId;
          objectjson['ProjectCode'] = this._ParamProjectCode;
          objectjson['ProjectType'] = "Project";
          objectjson['EmpCode'] = itemcurrent.value.EmpName;

          var EmpRole = this.EmployeeList.find(x => { return x.EmpCode == itemcurrent.value.EmpName }).RoleCode;

          objectjson['EmpRole'] = EmpRole;
          //objectjson['PositionInProject'] = itemcurrent.value.PositionInProject;
          objectjson['FlagRemoveAssignMemberFromClient'] = itemcurrent.value.FlagRemove;

          objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          arrayinsert.push(objectjson);
        });

        let strjson = JSON.stringify(arrayinsert);
        this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectMember/UpdateAssignMemberProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("SaveAssignMember fail")
            this.titlemodal = 'Save Assign Member fail.';
            this.detailmodal = 'Save Assign Member was saved fail.';
            $('#ModalError').modal();
          },
            async () => {
              console.log("SaveAssignMember = " + this.isSubmitted)
              await this.ReLoadAssignMember();
              this.loading(false);
              this.titlemodal = 'Saving Assign Member done.';
              this.detailmodal = 'Your member was updated successfully.';
              $('#ModalComplate').modal();
            }
          )

      } else {
        this.GlobalService.markFormGroupTouched(this.AssignMemberForm);
      }
    }
  }


  customAssignMemberSearch(term: string, item: EmpInfo) {
    term = term.toLocaleLowerCase();
    return item.EmpCode.toLocaleLowerCase().indexOf(term) > -1 || item.EmpName_TH.toLocaleLowerCase().indexOf(term) > -1;
  }

  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event[0];
    console.log(this.selectedemp)


  }

  empselect(num) {
    this.employeeselectrun = true;
    this.employeeselectreturnto = num;
    this.selectedemp = null;
    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {

    console.log(this.selectedEmp)

    if (this.selectedemp != null) {
      // hide modal Assign PM
      $('#ModalEmpSelect').modal('hide');
      this.employeeselectrun = false;


      this.onChanges(this.employeeselectreturnto, true, true)

      this.selectedemp = null;

    } else {
      alert("Please select an employee")
    }

  }

    // ----------------------- Function Assign Member Zone -----------------------------------------


  //---------------------- Sub Project Function ------------------------------------------------------

  async btnClick_showSubProjectList() {
    this.currentSubPageNumber = 1;
    this.isSubSearchSubmitted = true;

    this.LoadSubProjectAndCount();

  }


  async LoadSubProjectAndCount() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      this.LoadSubProject(auth_token);
      console.log("LIST MY")
      console.log(this.SubProjectList)

      this.OnLoadCountSubProjectList(auth_token);

      console.log("COUNT MY")
      console.log(this.SubProjectTotal)
    }
  }

  LoadSubProject(auth_token) {
    this.subscriptionLoadSubProjectList = this.LoadSubProjectList(auth_token)
      .subscribe(
        data => {
          this.subscriptionLoadSubProjectList.unsubscribe();
          this.SubProjectList = data;

        },
        err => {
          console.error('Observer got an error: ' + err)
        },
        () => {
          console.log('Observer got a complete notification')
        }

      )
  }


  LoadSubProjectList(auth_token): Observable<ProjectInfo[]> {
    var pathapi = "Project/GetProjectCriteria";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = ((this.currentSubPageNumber > 0 ? this.currentSubPageNumber : 1) - 1) * environment.PageSize;

    let data = {};
    data["ParentProjectCode"] = this.checkUndefinedString(this._ParamProjectCode);
    data["ProjectCode"] = this.checkUndefinedString(this.txtSearchSubProjectCode);
    data["ProjectName"] = this.checkUndefinedString(this.txtSearchSubProjectName);
    data["rowFetch"] = environment.PageSize;
    data["rowOFFSet"] = offset;
    data["FlagDelete"] = "N";
    let strjson = JSON.stringify(data);

    return this.httpClient
      .post<ProjectInfo[]>(this.baseurl + pathapi,
        strjson, httpOptions)

  }

  async clearSubSearchSection() {

    this.txtSearchSubProjectCode = "";
    this.txtSearchSubProjectName = "";
    this.isSubSearchSubmitted = false;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadSubProject(auth_token);
      this.OnLoadCountSubProjectList(auth_token);
    }
  }

  async OnSubLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadSubListPagination(traget);
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadSubProject(auth_token);
      }
    }

  }

  LoadSubListPagination(traget) {
    this.currentSubPageNumber = traget.currentPageNumber;
    this.totalSubPages = traget.totalPages;
  }

  OnLoadCountSubProjectList(auth_token) {
    //call function load count all ticket list on hand current role user
    this.LoadCountSubProjectList(auth_token).then(data => {
      this.SubProjectTotal = data;
      if (this.SubProjectTotal == 0) {
        this.currentSubPageNumber = 0;
      }
      this.totalSubPages = Math.ceil(this.SubProjectTotal / environment.PageSize);
    });
  }

  LoadCountSubProjectList(auth_token) {

    var pathapi = "Project/GetCountProjectCriteria";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };


    let data = {};
    data["ParentProjectCode"] = this.checkUndefinedString(this._ParamProjectCode);
    data["ProjectCode"] = this.checkUndefinedString(this.txtSearchSubProjectCode);
    data["ProjectName"] = this.checkUndefinedString(this.txtSearchSubProjectName);

    data["FlagDelete"] = "N";
    let strjson = JSON.stringify(data);

    return this.httpClient
      .post<number>(this.baseurl + pathapi,
        strjson, httpOptions)
      .toPromise()
  }


  async selectedSubTabChange(traget) {

    if (traget.tab.textLabel == 'Sub Project') {
      
    }


  }
  selectedFileName = '';
  
  onImportCSV(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const csvText = e.target.result;
      const rows = csvText.split('\n').map(row => row.trim()).filter(row => row);
      const headers = rows.shift()?.split(',').map(h => h.trim()) || [];

      const importedItems = rows.map(row => {
        const values = row.split(',').map(v => v.trim());
        const rowObj: any = {};
        headers.forEach((header, index) => {
          rowObj[header] = values[index] || '';
        });
        return rowObj;
      });

      const formArray = this.ProjectDetailForm.get('SetupForm.items') as FormArray;
      const existing = formArray.getRawValue();

      let added = 0;
      let skipped = 0;
      const duplicateList: string[] = [];
      const notFoundList: string[] = [];

      importedItems.forEach((item, index) => {
        const rowNum = index + 2; // header is row 1
        const taskName = item.BaselineTaskName?.trim();
        const stageName = item.BaselineType?.trim();

        const task = this.ListState.find(t =>
          t?.StateName?.toLowerCase().trim() === taskName?.toLowerCase()
        );
        const stage = this.Stagelist.find(s =>
          s?.LookupValue?.toLowerCase().trim() === stageName?.toLowerCase()
        );

        if (!task || !stage) {
          notFoundList.push(`Row ${rowNum}: ${taskName || '[Missing Task]'} / ${stageName || '[Missing Stage]'}`);
          skipped++;
          return;
        }

        const isDuplicate = existing.some(e =>
          (this.getStateNameFromCode(e.BaselineTaskName)?.toLowerCase().trim() || '') === taskName.toLowerCase() &&
          (this.getStageNameFromCode(e.BaselineType)?.toLowerCase().trim() || '') === stageName.toLowerCase()
        );

        if (isDuplicate) {
          skipped++;
          duplicateList.push(`${taskName} / ${stageName}`);
          return;
        }

        formArray.push(this.fb.group({
          BaselineTaskName: [task.StateCode, Validators.required],
          BaselineType: [stage.LookupCode, Validators.required],
          BaselineStartDate: [this.parseDate(item.BaselineStartDate), Validators.required],
          BaselineEndDate: [this.parseDate(item.BaselineEndDate), Validators.required],
          BaselineRemark: [item.BaselineRemark || '']
        }));

        added++;
      });

      // Create SweetAlert2 HTML
      const resultHtml = `
        <div style="text-align:left;font-size:14px;">
          <p><span style="color:green;">✅</span> <strong>Added:</strong> ${added}</p>
          <p><span style="color:red;">⛔</span> <strong>Skipped:</strong> ${skipped}</p>

          ${duplicateList.length > 0 ? `
            <hr>
            <strong>🔁 Duplicate Tasks:</strong>
            <ul style="padding-left:20px;">
              ${duplicateList.map(d => `<li>- ${d}</li>`).join('')}
            </ul>
          ` : ''}

          ${notFoundList.length > 0 ? `
            <hr>
            <strong>❓ Not Found Task/Stage:</strong>
            <ul style="padding-left:20px;">
              ${notFoundList.map(n => `<li>- ${n}</li>`).join('')}
            </ul>
          ` : ''}
        </div>
      `;

      Swal.fire({
        title: '<i class="fa fa-file-import text-success"></i> Import Result',
        html: resultHtml,
        icon: added > 0 ? 'success' : (skipped > 0 ? 'warning' : 'info'),
        confirmButtonText: 'OK',
        width: 640,
        customClass: {
          popup: 'swal2-rounded'
        }
      });
    };

    reader.readAsText(file);
  }



  // Helper to match name from code for duplication check
  getStateNameFromCode(code: string): string {
    return this.ListState.find(t => t.StateCode === code)?.StateName || '';
  }

  getStageNameFromCode(code: string): string {
    return this.Stagelist.find(s => s.LookupCode === code)?.LookupValue || '';
  }

  // Format date as YYYY-MM-DD
  parseDate(dateStr: string): string {
    if (!dateStr) return '';
    const parts = dateStr.split('/');
    if (parts.length !== 3) return dateStr;
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }


}
